import { NavigationButtons } from '../NavigationButtons';
import { ElectronicRegistration, MainDirections, OnlineContract, SmartDeal } from './components';
import { useToScroll } from 'shared/hooks/useToScroll';
import { BlueUtpEcoSystem } from './components/BlueUtpEcoSystem';
import { BTN_CORE_BUSINESS_LINK, BTN_DAILY_LINK, BTN_TECHNOLOGIES_LINK } from 'shared/constants/links';

export const TransactionalBusiness: React.FC = () => {
  useToScroll();

  return (
    <>
      <MainDirections />
      <SmartDeal />
      <ElectronicRegistration />
      <OnlineContract />
      <BlueUtpEcoSystem />
      <div />
      <NavigationButtons links={[BTN_TECHNOLOGIES_LINK, BTN_CORE_BUSINESS_LINK, BTN_DAILY_LINK]} />
    </>
  );
};
